import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  isSessionExpired,
  isSessionTracking,
  isSessionWarning,
  sessionExpiresAt,
  sessionSecondsRemaining,
  sessionTickSchedule,
} from './app-lifecycles.helpers';
import { AppLifecyclesState } from './app-lifecycles.models';
import { APP_LIFECYCLES_FEATURE_KEY } from './app-lifecycles.reducer';

export const selectAppLifecyclesState =
  createFeatureSelector<AppLifecyclesState>(APP_LIFECYCLES_FEATURE_KEY);

export const selectIsPreAuth = createSelector(
  selectAppLifecyclesState,
  (state) => state.preAuth
);

export const selectIsPostAuth = createSelector(
  selectAppLifecyclesState,
  (state) => state.postAuth
);

export const selectIsPreAuthorization = createSelector(
  selectAppLifecyclesState,
  (state) => state.preAuthorization
);

export const selectIsPostAuthorization = createSelector(
  selectAppLifecyclesState,
  (state) => state.postAuthorization
);

export const selectLastAuthorizationChangeTimestamp = createSelector(
  selectAppLifecyclesState,
  (state) => state.lastAuthorizationChangeTimestamp
);

export const selectIsPreLogout = createSelector(
  selectAppLifecyclesState,
  (state) => state.preLogout
);

export const selectIsPostLogout = createSelector(
  selectAppLifecyclesState,
  (state) => state.postLogout
);

// --- Session inactivity (EDUS-2655) ---
//
// Every value below is derived from the two timestamps in `SessionState`. The
// predicates live in `app-lifecycles.helpers.ts` so the reducer can apply the
// same rules — notably raw activity stops extending the session
// once the countdown is on screen.

export const selectSession = createSelector(
  selectAppLifecyclesState,
  (state) => state.session
);

export const selectLastActivityAt = createSelector(
  selectSession,
  (session) => session.lastActivityAt
);

export const selectIsSessionTracking = createSelector(
  selectSession,
  isSessionTracking
);

export const selectSessionExpiresAt = createSelector(
  selectSession,
  sessionExpiresAt
);

/** Drives the warning modal: true exactly while the countdown should show. */
export const selectIsWarningActive = createSelector(
  selectSession,
  isSessionWarning
);

/** Drives termination. */
export const selectIsSessionExpired = createSelector(
  selectSession,
  isSessionExpired
);

/** Countdown text in the warning modal. */
export const selectSecondsRemaining = createSelector(
  selectSession,
  sessionSecondsRemaining
);

/** Drives the tick scheduler in `session-timeout.effects.ts`. */
export const selectTickSchedule = createSelector(
  selectSession,
  sessionTickSchedule
);
